import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {ExpressionModel} from "../../expression.model";

@Component({
  selector: 'app-expression-formula-view',
  templateUrl: './expression-formula-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host {display: flex; flex: 1 1 auto!important; flex-wrap: wrap !important;}'],
})
export class ExpressionFormulaViewComponent implements OnInit {
  @Input() expression: ExpressionModel;
  @Input() placeholder: string;
  constructor() { }

  ngOnInit(): void {
  }
}
